import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('TermsAndConditions'))}}),_c(VBtn,{attrs:{"color":"secondary","dark":""},on:{"click":_vm.onCloseClick}},[_vm._v(_vm._s(_vm.$t("Close")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }